/* eslint-disable */
import requestService from "../../Domain/Service/request";
import template from './template.html';

let LifeHackBannerView = Backbone.Epoxy.View.extend({
	viewModel: new (Backbone.Model.extend({
		defaults: {
			loading: false,
			lifeHackBannerEmailWasSend: false
		}
	}))(),
	template: template,
	bindings: {
		".js-step-1": "toggle:not(lifeHackBannerEmailWasSend)",
		".js-step-2": "toggle:lifeHackBannerEmailWasSend",
		"button": "classes:{loading:loading}"
	},
	initialize: function () {
		this.$el.html(this.template);
		this.initDOMEvents();
	},
	initDOMEvents: function () {
		var self = this;
		setTimeout(function () {
			var $form = self.$el.find('form');
			$form.validate({
				errorElement: "div",
				rules: {
					email: {
						required: true,
						email: true
					}
				},
				messages: {
					email: {
						required: 'Обязательное поле',
						email: 'Введите правильный email'
					}
				}
			});

			$form.on("click", 'button', function (e) {
				e.preventDefault();
				e.stopPropagation();
				if ($form.valid() && !self.viewModel.get("loading")) {
					self.formSubmit($form.find('input').val());
				}
			})
		}, 10);
	},
	formSubmit: function (email) {
		var self = this;
		self.viewModel.set("loading", true);
		requestService({
			type: "POST",
			url: "/subscriber/hackSubscribe",
			data: {
				email: email
			}
		}).done(function (data) {
			self.viewModel.set("loading", false);
			if (data && data.success) {
				self.viewModel.set("lifeHackBannerEmailWasSend", true);
			}
		}).fail(function () {
			self.viewModel.set("loading", false);
		})
	}
});

export default LifeHackBannerView;
